import { Empty } from "antd";
import React, { useEffect, useState } from "react";
import CommonSelectV2 from "../../../../core/common/commonSelectV2";
import { Link } from "react-router";
import useFetch from "../../../../hooks/useFetch";
import PreLoader from "../../../../core/common/preLoader";
import { API } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import { useAccess } from "../../../../hooks/accessContext";


interface Props {
    code: string
    heading: string
    formHeading: string
    options?: any[]
    refresh?: () => void
    data?: any
    defaultValue?: any
    type: 'CURRICULUM' | 'COURSE' | 'SUBJECT'
    editable?: boolean
}

const AddMembersForm = (props: Props) => {
    const { hasAcademicMgntDelete, hasAcademicMgntEdit} = useAccess()
    const [showEditForm, setShowEditForm] = useState<boolean>(false)
    const [isEditFormVisible, setIsEditFormVisible] = useState(true);
    const [errorMessage, setErrorMessage] = useState<string | undefined>("");
    const [showMsgBox, setShowMsgBox] = useState(false);
    const [code, setCode] = useState<string>() ;
    const {isLoading, data, error, status, callFetch } = useFetch();
    

    const reset = () =>{
        setCode(undefined)
    }

    useEffect(() => {
        if(data && status && status < 299){
            if(props.refresh){
                props.refresh()
            }
            setShowMsgBox(true)
            reset()
        }
    }, [status]);


    useEffect(() => {
        if(error){
            if(error.response?.data){
            setErrorMessage(error.response?.data)
            setShowMsgBox(true)
            } else{
            setErrorMessage('Something went wrong please try again later.')
            setShowMsgBox(true)
            }
        }
    }, [error]);


    const handleSubmit = (event:any)=> {
        event.preventDefault();
        setErrorMessage("")
        if(props.type === 'CURRICULUM'){
            addCourseInCurriculumSubmit()
        } else if (props.type === 'COURSE'){
            addSubjectInCourseSubmit()
        } else if (props.type === 'SUBJECT') {
            addSyllabusForSubjectSubmit()
        }
    }

    const addSubjectInCourseSubmit = ()=> {
        callFetch(API.COURSE_SUBJECT,
                  'POST',
                  getAPIHeaders(),
                  null,
                  {
                    courseCode: props?.code,
                    subjectCode: code
                  }
        ).catch((err) => {});
    }

    const addCourseInCurriculumSubmit = ()=> {
        callFetch(API.CURRICULUM_COURSE,
                  'POST',
                  getAPIHeaders(),
                  null,
                  {
                    curriculumCode: props?.code,
                    courseCode: code
                  }
        ).catch((err) => {});
    }

    const addSyllabusForSubjectSubmit = ()=> {
        callFetch(API.SUBJECT_SYLLABUS,
                  'POST',
                  getAPIHeaders(),
                  null,
                  {
                    subjectCode: props?.code,
                    syllabusCodes: [...props?.data?.map((item:any)=>item.code), code]
                  }
        ).catch((err) => {});
    }

    const handleRemove = (delCode:string)=> {
        setErrorMessage("")
        if(delCode){
            if(props.type === 'CURRICULUM'){
                removeCourseInCurriculumSubmit(delCode)
            } else if (props.type === 'COURSE'){
                removeSubjectInCourseSubmit(delCode)
            } else if (props.type === 'SUBJECT') {
                removeSyllabusForSubjectSubmit(delCode)
            }
        }
    }

    const removeSubjectInCourseSubmit = (delCode: string)=> {
        callFetch(API.COURSE_SUBJECT,
                  'DELETE',
                  getAPIHeaders(),
                  null,
                  {
                    courseCode: props?.code,
                    subjectCode: delCode
                  }
        ).catch((err) => {});
    }

    const removeCourseInCurriculumSubmit = (delCode: string)=> {
        callFetch(API.CURRICULUM_COURSE,
                  'DELETE',
                  getAPIHeaders(),
                  null,
                  {
                    curriculumCode: props?.code,
                    courseCode: delCode
                  }
        ).catch((err) => {});
    }

    const removeSyllabusForSubjectSubmit = (delCode: string)=> {
        callFetch(API.SUBJECT_SYLLABUS,
                  'DELETE',
                  getAPIHeaders(),
                  null,
                  {
                    subjectCode: props?.code,
                    syllabusCode: delCode
                  }
        ).catch((err) => {});
    }

    // Visualisation Effect
    useEffect(() => {
        if (!showEditForm) {
          setTimeout(() => {
            setIsEditFormVisible(false)
            }, 400);
        } else {
            setIsEditFormVisible(true);
        }
    }, [showEditForm]);


    useEffect(() => {
        if (showMsgBox) {
            setTimeout(() => {
                setShowMsgBox(false)
            }, 1500);
        } 
    }, [showMsgBox]);
      
    const renderList = () => {
        return (
            <>
                {
                    props?.data?.length
                        ?
                        <>
                            {props?.data?.map((sub: any) => {
                                return (
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="ms-2">
                                                <h6 className="fw-medium">{sub?.title}</h6>
                                                <p className="fs-12">{sub?.code}</p>
                                            </div>
                                        </div>
                                        {
                                            props?.editable && hasAcademicMgntDelete()
                                            ?
                                                <Link 
                                                    to="#" 
                                                    className="user-icon mb-2"
                                                    onClick={()=>{
                                                        handleRemove(sub?.code)
                                                    }}
                                                >
                                                    <i className="ti ti-trash fs-16" />
                                                </Link>
                                            :
                                            <></>
                                        }
                                    </div>
                                )
                            })
                            }
                        </>

                        :
                        <>
                            <Empty />
                        </>
                }
            </>
        )
    }

    const renderForm = () => {
        return (
            showMsgBox
            ?
            <div className="pb-0">
                <div className="d-flex pb-2 justify-content-center">
                    {
                        errorMessage
                        ?
                        <>
                        <label className="text-danger fw-medium" > {errorMessage} </label>
                        </>
                        :
                        <>
                        <label className="text-dark fw-medium" > Updated {props.type === 'CURRICULUM' ? 'Courses' : props.type === 'COURSE' ? 'Subjects' : props.type ===  'SUBJECT' ? 'Syllabus' : '' } List Successfully </label>
                        </>
                    }
                </div>
            </div>
            :
            <div className="pb-0">
                <div className="pb-2">
                    <label className="text-dark fs-14 fw-medium mb-1">{ props.formHeading}</label>
                    <CommonSelectV2
                        onChange={(value)=>{
                            setCode(value)
                        }}  
                        className="select"
                        defaultValue={props.defaultValue}
                        options={props.options || []}
                        placeHolder="Select"
                        
                    />
                </div>

                <div className="d-flex justify-content-end">
                    {/* <button className="btn btn-sm btn-secondary me-2">Cancel </button> */}
                    <button 
                        className="btn btn-sm btn-dark"
                        type="submit"
                        onClick={handleSubmit}
                        disabled={!code}
                    >Save </button>
                </div>
            </div>
            
        )
    }

    return (
        <div>
            <PreLoader showLoader={isLoading} />
            <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-3"> {props?.heading} </h4>

                {
                    props?.editable && hasAcademicMgntEdit()
                    ?
                    <Link
                        to="#"
                        className="fs-12 mb-3"
                        onClick={()=>{
                            if(showEditForm){
                                reset()
                            }
                            setShowEditForm(!showEditForm)

                        }}
                    >
                        <i className="ti ti-edit me-1" />
                        {isEditFormVisible ? 'Hide Form' : 'Update List'}
                    </Link>
                    :
                    <></>
                }

            </div>
            { 
                    isEditFormVisible && props?.editable &&
                    <>
                        <div className={`card shadow-none mb-3 fade ${showEditForm && 'show'} `}>
                            <div className="card-body p-3 ">
                                {renderForm()}
                            </div>
                        </div>

                    </>
            }
            <div className="card shadow-none mb-0">
                <div className="card-body p-3 ">
                    {renderList()}
                </div>
            </div>
        </div>
    )
}

export default AddMembersForm